import React,{useState,useEffect} from 'react'
import DisplayData from './DisplayResult';
import '../App.css';
import axios from 'axios';
import reset from './reset.png'
function Validator(){

    const [input,setInput]= useState({
        certificate_number:''
    });
    const [result,setResult]= useState(null);
    const [isButtonDisabled, setIsButtonDisabled] = useState({opacity:0.3});


    const BASE_URL="https://rc.prod-app.in";

    const inputHandler = (e)=>{
        setInput ({...input,[e.target.name]:e.target.value})
        
    }

    const verification = () =>{    
        if(input.certificate_number.length >= 7 ){
                return axios.post(BASE_URL+"/certificate_validation",input).then((res)=>{
                    setResult(res.data);         
            });
        }
       
        
              
    }
    
    useEffect(() => {
        
        if (input.certificate_number.length < 7 ) {
            setIsButtonDisabled({opacity:0.3});
        }
        else {
            setIsButtonDisabled({opacity:1});
        }
     }, [input]);
     

    return(
        <div className='validator-Container'>
            <div className='verifyData'>
                    <h2>Validate your Certificate</h2>
                    <div className='inputContainer'>
                        <input type="text" name="certificate_number" placeholder='Enter Certificate Number' onChange={inputHandler}/>
                        <button className='validatorBtn'  style={isButtonDisabled}  onClick={()=>{verification()}}>Validate</button>
                     {result && ( <a onClick={()=>{window.location.reload(true)}}><img className="resetImg" src={reset}/></a>)}
                    
                    </div>
                        {   result ? <DisplayData  output={result}  baseurl={BASE_URL}   certfcno={input.certificate_number}/> : ''  } 
            </div>
           
        </div>
    )

}
export default Validator;